import { getLastPartOfPath } from '@src/documents/hooks/useFindAllDocumentsForOrder';
import type { Document } from '@src/orders/domain/PermitApplication';
import { DocumentsFields } from '@src/permits/completePermit/fields/CompletePermitFields';
import type { UseFieldArrayReturn } from 'react-hook-form';
import type { InferType } from 'yup';
import { object } from 'yup';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const doc = object().shape({
  [DocumentsFields.fieldName]: DocumentsFields.validator,
});
export type FormDocumentType = InferType<typeof doc>;

export const upsertFormDocument = (
  newDocument: Document,
  formFields: UseFieldArrayReturn<FormDocumentType>,
) => {
  const { append, fields, update } = formFields;
  const index = fields.findIndex(
    (field) => field.name === getLastPartOfPath(newDocument.key),
  );
  if (index !== -1) {
    update(index, {
      documentId: formFields.fields[index].documentId,
      name: getLastPartOfPath(newDocument.key),
      displayName: newDocument.displayName,
      sendToClient: newDocument.sendToClient,
    });
    return;
  }
  append({
    documentId: newDocument.documentId,
    name: getLastPartOfPath(newDocument.key),
    displayName: newDocument.displayName,
    sendToClient: newDocument.sendToClient,
  });
};
